import React, { useState } from "react";
import { Modal, Box, Typography, TextField, Button } from "@mui/material";
import { useWebScrapingAPI } from "@/hooks/useAdminDashboardService";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const style = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#121212",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  color: "white",
  border: "2px solid #501b99",
};

const ModalForm: React.FC<{
  open: boolean;
  setOpen: (val: boolean) => void;
}> = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen(false);
    setFormData({ linkedin: "", website: "" });
    setErrors({ linkedin: "", website: "" });
  };
  const navigate = useNavigate();
  const { mutate, isPending } = useWebScrapingAPI();
  const id = localStorage.getItem("tenantId") || "";
  const [formData, setFormData] = useState({
    linkedin: "",
    website: "",
  });

  const [errors, setErrors] = useState({
    linkedin: "",
    website: "",
  });

  const validate = () => {
    const newErrors = { linkedin: "", website: "" };
    let isValid = true;

    if (!formData.linkedin.trim()) {
      newErrors.linkedin = "Linkedin URL is required";
      isValid = false;
    }

    if (!formData.website.trim()) {
      newErrors.website = "WebSite URL is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const [lastFetchedUrl, setLastFetchedUrl] = useState("");

  const handleWebScraping = () => {
    if (!id) return alert("Tenant ID not found!");
    const trimmedUrl = formData.website.trim().toLowerCase();
    if (lastFetchedUrl && lastFetchedUrl === trimmedUrl) {
      toast.error("Details for this URL have already been fetched.");
      return;
    }
    const payload = {
      id,
      linkedin: formData.linkedin,
      website: formData.website,
    };
    mutate(payload, {
      onSuccess: (data) => {
        setLastFetchedUrl(trimmedUrl);
        toast.success("Details fetched! Redirecting to company profile...");
        navigate("/company-profile", {
          state: data?.data,
        });
        handleClose();
      },
      onError: (error: any) => {
        console.error("Web scraping failed:", error);
        if (error?.response?.status === 422) {
          toast.error("This company doesn't allow scraping data. Please fill manually.");
        } else {
          toast.error(error?.response?.data?.message || error?.message || "Error: Try again in 1 min, or fill manually.");
        }
      },
    });
  };

  const textFieldStyles = {
    mb: 2,
    input: { color: "white", caretColor: "white" },
    label: { color: "white" },
    "& input::placeholder": {
      color: "white",
      opacity: 1,
    },
    "& label.Mui-focused": {
      color: "white",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#501b99",
      },
      "&:hover fieldset": {
        borderColor: "#501b99",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#501b99",
      },
    },
    "& .MuiFormHelperText-root": { color: "#f44336" },
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Typography variant="h6" mb={2}>
            Web Scraping
          </Typography>
          <TextField
            fullWidth
            label="Linkedin URL"
            value={formData.linkedin}
            onChange={(e) =>
              setFormData({ ...formData, linkedin: e.target.value })
            }
            error={!!errors.linkedin}
            helperText={errors.linkedin}
            sx={textFieldStyles}
          />
          <TextField
            fullWidth
            label="WebSite URL"
            value={formData.website}
            onChange={(e) =>
              setFormData({ ...formData, website: e.target.value })
            }
            error={!!errors.website}
            helperText={errors.website}
            sx={textFieldStyles}
          />
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button onClick={handleClose} variant="outlined" color="inherit">
              Cancel
            </Button>
            <Button
              onClick={() => validate() && handleWebScraping()}
              variant="contained"
              sx={{
                backgroundColor: "#501b99",
                "&:hover": {
                  backgroundColor: "#3e117a",
                },
              }}
            >
              {isPending ? "Submitting..." : "Submit"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ModalForm;
